import type { PageResponseType, ProductSeries, ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = '/api/v1/admin';

export const adminProductSeriesApi = {
  /**
   * @description 获取产品线列表
   */
  getList(params: {
    seriesName?: string;
    productLineId?: number;
    enable?: number;
    pageSize?: number;
    current?: number;
  }): PageResponseType<ProductSeries> {
    return request({
      method: 'GET',
      url: `${prefix}/productSeries`,
      params,
    });
  },

  /**
   * @description 增加产品线
   */
  add(data: { productLineId: number } & any): ResponseType {
    return request({
      method: 'POST',
      url: `${prefix}/productSeries`,
      data,
    });
  },

  /**
   * @description 更新产品线
   */
  update(id: number, data: any): ResponseType {
    return request({
      method: 'PUT',
      url: `${prefix}/productSeries/${id}`,
      data,
    });
  },

  /**
   * @description 删除产品线
   */
  del(id: number): ResponseType {
    return request({
      method: 'DELETE',
      url: `${prefix}/productSeries/${id}`,
    });
  },

  /**
   * @description 获取所有产品系列
   */
  getAll(): PageResponseType<ProductSeries> {
    return request({
      method: 'GET',
      url: `${prefix}/productSeries`,
      params: {
        current: 1,
        pageIndex: 1,
        pageSize: 100,
        productLineId: 0,
      },
    });
  },
};
